module.exports = __webpack_public_path__ + "img/stickers-taxe-habitation.d1c1ab83.jpg";